<template>
    <div class="pos_settings">
        <div
            class="form-group pos-setting-item"
            :class="{ 'bool-group': is_bool_settings(key_name, pos_params[key_name]) }"
            v-for="(key_val, key_name) in pos_params"
            v-if="key_name.length > 0 && key_name != 'id'"
            :key="key_name"
        >
            <label class="form-label">
                {{ __t(key_name.toUpperCase()) }}
            </label>

            <!-- обычные поля -->
            <div
                class="input-group input-group-lg bg-white shadow-inset-2 with_icon"
                v-if="!is_special_settings(key_name, pos_params[key_name])"
            >
                <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent border-left-0 border-right-0 py-1 px-3">
                        <span class="icon-stack fs-xxl">
                            <i class="base-7 icon-stack-3x color-primary-500"></i>
                            <i class="fal fa-database icon-stack-1x text-white"></i>
                        </span>
                    </span>
                </div>

                <b-form-input
                    debounce="300"
                    class="form-control bg-transparent pl-5"
                    :key="'input_' + key_name"
                    @update="on_change_value(key_name)"
                    v-model="pos_params[key_name]"
                    :id="'pos_param_' + key_name"
                />
            </div>

            <!-- boolean поля -->
            <div
                class="bool-setting"
                v-if="is_bool_settings(key_name, pos_params[key_name])"
            >
                <b-form-radio-group
                    :id="'bool_' + key_name"
                    @update="on_change_value(key_name)"
                    v-model="pos_params[key_name]"
                    button-variant="outline-primary"
                    :options="[
                        { text: __t('YES'), value: true },
                        { text: __t('NO'), value: false }
                    ]"
                    :name="'radios-btn-' + key_name"
                    buttons
                />
            </div>

            <!-- поля-массивы (тегами) -->
            <div v-if="is_array_settings(pos_params[key_name])">
                <v-select
                    class="imc_reasons"
                    taggable
                    multiple
                    :key="'array_' + key_name"
                    v-model="pos_params[key_name]"
                    @input="on_change_value(key_name)"
                />
            </div>

            <!-- db params -->
            <div v-if="key_name == 'db_params'">
                <pos_db :cur_db="pos_params[key_name]"></pos_db>
            </div>
        </div>
    </div>
</template>

<script>
import { createHelpers } from "vuex-map-fields";
import vSelect from "vue-select";
import Pos_db from "../../../aggregators/base/location_modal/db_parmas/pos_db.vue";
import yes_no from "../../../sys/radio/yes_no.vue";
import Fileload from "../../../sys/file_loader/fileload.vue";

const { mapFields } = createHelpers({
    getterType: "pos/getPosStateField",
    mutationType: "pos/updatePosStateField",
});

export default {
    name: "pos_general_settings",

    components: {
        Fileload,
        Pos_db,
        yes_no,
        vSelect,
    },

    methods: {
        is_valid_key(val) {
            return val != null && val.length > 1;
        },

        on_change_value(key_name) {
            if (this.pos_params.hasOwnProperty(key_name)) {
                this.$emit("on_change", {
                    key_name: key_name,
                    key_val: this.pos_params[key_name],
                    key_type: "general",
                });
            }
        },

        is_bool_settings(key_name, key_val) {
            return typeof key_val === "boolean";
        },

        is_array_settings(key_val) {
            return Array.isArray(key_val);
        },

        is_special_settings(key_name, key_val) {
            let res = [
                "db_params",
                "excel_file",
                'scheduler'
                // "round_product",
            ].includes(key_name);

            return res || this.is_bool_settings(key_name, key_val) || this.is_array_settings(key_val);
        },

        on_loading_files() {},
    },

    computed: {
        cur_params() {
            return this.pos_item.params;
        },

        pos_params() {
            return this.pos_item.pos_params;
        },

        ...mapFields([
            "pos_item",
            "is_load",
        ]),
    },
};
</script>

<style scoped>
.pos_settings {
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    margin-right: -8px;
}

.pos-setting-item {
    width: 100%;
    padding-left: 8px;
    padding-right: 8px;
}

.pos-setting-item.bool-group {
    width: 33.3333%;
}

.bool-setting {
    width: 200px;
}

.bool-setting ::v-deep .btn-group,
.bool-setting ::v-deep .btn-group-toggle {
    width: 100%;
    display: flex;
}

.bool-setting ::v-deep .btn {
    flex: 1;
    white-space: nowrap;
    padding-left: 8px;
    padding-right: 8px;
}

.bool-group .form-label {
    min-height: 34px;
    display: flex;
    align-items: flex-end;
}

/* мобилка — по 3 в ряд */
@media (max-width: 768px) {
    .pos-setting-item.bool-group {
        width: 33.3333%;
    }
}

/* совсем узкий экран */
@media (max-width: 420px) {
    .pos-setting-item.bool-group {
        width: 50%;
    }
}
</style>
